export const defaultColumnWidth = 250;
export const defaultRowHeight = 24;

export const frozenColumnStyle = {
  position: 'sticky',
  left: 0,
  zIndex: 30,  // Higher base z-index for frozen column
  boxShadow: '6px 0 12px -3px rgba(0,0,0,0.15), 3px 0 6px -2px rgba(0,0,0,0.08)',
  opacity: 1,  // Ensure opacity is always 1
  transform: 'translate3d(0, 0, 0)',  // Force GPU acceleration with 3D
  willChange: 'transform',  // Optimize for animations
  backfaceVisibility: 'hidden',  // Prevent flickering
  WebkitBackfaceVisibility: 'hidden',
  perspective: 1000,
  WebkitPerspective: 1000,
};

export const frozenColumnAfterStyle = {
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    width: '2px',
    background: 'linear-gradient(to bottom, transparent, rgba(226,232,240,0.5), transparent)',
    zIndex: 30,
  }
};

export const datePickerStyles = `
  .custom-date-picker {
    width: 100% !important;
  }

  .custom-date-picker .ant-picker-input > input {
    font-family: monospace;
    letter-spacing: 1px;
  }

  .custom-date-picker .ant-picker-input > input::placeholder {
    letter-spacing: normal;
  }

  /* Style for the format hint */
  .date-format-hint {
    position: absolute;
    top: -20px;
    left: 0;
    font-size: 11px;
    color: #6b7280;
    background: white;
    padding: 2px 6px;
    border-radius: 4px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    opacity: 0;
    transform: translateY(5px);
    transition: all 0.2s ease;
  }

  .date-picker-wrapper:hover .date-format-hint,
  .date-picker-wrapper:focus-within .date-format-hint {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const spreadsheetStyles = `
  /* Modern frozen column effect */
  .frozen-column-cell {
    transform: translate3d(0, 0, 0);
    will-change: transform;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    perspective: 1000px;
    -webkit-perspective: 1000px;
  }
  
  .frozen-column-cell::after {
    content: '';
    position: absolute;
    top: 0;
    right: -2px;
    bottom: 0;
    width: 4px;
    background: linear-gradient(to right, rgba(59,130,246,0.15), transparent);
    z-index: 35;
    pointer-events: none;
  }
  
  /* Chrome-specific sticky header fixes */
  thead {
    transform: translate3d(0, 0, 0);
    will-change: transform, top;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    contain: layout style paint;
    isolation: isolate;
  }
  
  /* Chrome GPU acceleration for sticky positioning */
  thead.sticky {
    position: -webkit-sticky;
    position: sticky;
  }
  
  /* Force repaint optimization in Chrome */
  @supports (-webkit-appearance: none) {
    thead {
      -webkit-transform: translateZ(0);
      -webkit-filter: blur(0);
      -webkit-perspective: 1000;
    }
    
    thead th {
      -webkit-transform: translate3d(0, 0, 0);
      -webkit-backface-visibility: hidden;
    }
  }
  
  /* Force hardware acceleration on the scrollable container */
  .scroll-container {
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    will-change: scroll-position;
    -webkit-overflow-scrolling: touch;
    contain: paint;
  }
  
  /* Ensure frozen cells maintain proper rendering */
  td.frozen-column-cell {
    position: sticky !important;
    left: 0 !important;
    z-index: 30 !important;
  }
  
  th.frozen-column-cell {
    position: sticky !important;
    left: 0 !important;
    z-index: 35 !important;
  }

  /* Smooth scrollbar styling */
  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }
  
  ::-webkit-scrollbar-track {
    background: rgba(248,250,252,0.5);
    border-radius: 6px;
  }
  
  ::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);
    border-radius: 6px;
    border: 2px solid rgba(248,250,252,0.5);
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
  }

  /* Cell hover effects - simplified */
  td {
    position: relative;
    overflow: visible;
  }

  /* Resize handle styling */
  .col-resize-handle:hover,
  .row-resize-handle:hover {
    background: linear-gradient(to bottom, transparent, #3b82f6, transparent) !important;
  }

  /* Selection animation */
  @keyframes selectionPulse {
    0% { box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.4); }
    70% { box-shadow: 0 0 0 10px rgba(99, 102, 241, 0); }
    100% { box-shadow: 0 0 0 0 rgba(99, 102, 241, 0); }
  }
  
  td.active-cell {
    animation: selectionPulse 2s infinite;
  }

  /* Modern dropdown styling */
  .css-y4tg56 {
    display: flex !important;
  }
`;

export const tableVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.2,
      ease: 'easeOut',
    },
  },
};

export const rowVariants = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: { duration: 0 },
  },
};